var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrevIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.03 6.47032C9.88937 6.32987 9.69875 6.25098 9.5 6.25098C9.30125 6.25098 9.11063 6.32987 8.97 6.47032L3.97 11.4703C3.82955 11.6109 3.75066 11.8016 3.75066 12.0003C3.75066 12.1991 3.82955 12.3897 3.97 12.5303L8.97 17.5303C9.03866 17.604 9.12146 17.6631 9.21346 17.7041C9.30546 17.7451 9.40477 17.7671 9.50548 17.7689C9.60618 17.7707 9.70621 17.7522 9.7996 17.7144C9.89299 17.6767 9.97782 17.6206 10.049 17.5494C10.1203 17.4781 10.1764 17.3933 10.2141 17.2999C10.2518 17.2065 10.2704 17.1065 10.2686 17.0058C10.2668 16.9051 10.2448 16.8058 10.2038 16.7138C10.1628 16.6218 10.1037 16.539 10.03 16.4703L6.31 12.7503H14.5C15.213 12.7503 16.3 12.9703 17.187 13.6093C18.035 14.2193 18.75 15.2443 18.75 17.0003C18.75 17.1992 18.829 17.39 18.9697 17.5306C19.1103 17.6713 19.3011 17.7503 19.5 17.7503C19.6989 17.7503 19.8897 17.6713 20.0303 17.5306C20.171 17.39 20.25 17.1992 20.25 17.0003C20.25 14.7563 19.298 13.2803 18.063 12.3913C16.867 11.5303 15.453 11.2503 14.5 11.2503H6.31L10.03 7.53032C10.1705 7.38969 10.2493 7.19907 10.2493 7.00032C10.2493 6.80157 10.1705 6.61094 10.03 6.47032Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrevIcon);
export default __webpack_public_path__ + "static/media/prevIcon.321acbf51b645113c1c53285618647be.svg";
export { ForwardRef as ReactComponent };